// extracted by mini-css-extract-plugin
export default {"columnSpace":"PileParameters_columnSpace__7pQj8"};